import React from 'react';
import './PixelArtLoader.css';

const PixelArtLoader = ({ message = "LOADING", subMessage = "Please wait..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      {/* Pixel Art Chef Animation */}
      <div className="mb-8 relative">
        <div className="w-24 h-24 relative chef-animation">
          <img 
            src="/images/chef_pre_fire.png" 
            alt="Chef Pre-Fire" 
            className="absolute inset-0 w-full h-full object-contain chef-pre-fire"
          />
          <img 
            src="/images/chef_fire.png" 
            alt="Chef Fire" 
            className="absolute inset-0 w-full h-full object-contain chef-fire"
          />
        </div>
      </div>
      
      {/* Loading Text */}
      <div className="text-center mb-6">
        <div className="font-mono text-lg uppercase tracking-wider text-neutral-900 mb-2">
          {message}
        </div>
        <div className="text-sm text-neutral-900 opacity-60 font-mono">
          {subMessage}
        </div>
      </div>
      
      {/* Pixel Loading Bar */}
      <div className="w-32 h-4 bg-neutral-0 hairline relative overflow-hidden">
        <div className="absolute top-0 left-0 h-full bg-neutral-900 pixel-load-animation">
        </div>
        {/* Pixel pattern overlay */}
        <div className="absolute inset-0 pixel-pattern"></div>
      </div>
    </div>
  );
};

export default PixelArtLoader;
